import React from 'react';
import Link from 'next/link';
import { GenieLogo } from '@/components/ui/icons/genie-logo';
import { WorkflowLogo } from '@/components/ui/icons/workflow-logo';

export function FoundersInfo() {
  return (
    <div className="flex space-x-6 opacity-80 hover:opacity-100 transition-opacity duration-300 mb-2 md:mb-0">
      {/* Founder & Director */}
      <div className="flex flex-row md:flex-col">
        <div className="pb-[1px] md:pb-[5px]">
          <GenieLogo className="w-[24px] h-[24px] text-black" />
        </div>
        <div className="pt-[2px] pl-[5px] md:p-[0] flex flex-col gap-[2px]">
          <p className="text-[8px] font-superior font-medium tracking-tight leading-none text-gray-500">
            [ FOUNDER & DIRECTOR ]
          </p>
          <Link href="https://genie.art" target="_blank" rel="noopener noreferrer" className="inline-block">
            <p className="text-[10px] font-superior font-bold tracking-tight">GENIE</p>
          </Link>
        </div>
      </div>
      {/* Co-Founder */}
      <div className="flex flex-row md:flex-col">
        <div className="pb-[5px]">
          <WorkflowLogo className="w-[24px] h-[24px] text-black" />
        </div>
        <div className="pt-[2px] pl-[5px] md:p-[0] flex flex-col gap-[2px]">
          <p className="text-[8px] font-superior font-medium tracking-tight leading-none text-gray-500">
            [ CO-FOUNDER ]
          </p>
          <Link href="https://workflow.art" target="_blank" rel="noopener noreferrer" className="inline-block">
            <p className="text-[10px] font-superior font-bold tracking-tight">WORKFLOW</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
